import { render } from "./ChecklistItem.vue?vue&type=template&id=810e8af0&scoped=true"
import script from "./ChecklistItem.vue?vue&type=script&lang=js"
export * from "./ChecklistItem.vue?vue&type=script&lang=js"

import "./ChecklistItem.vue?vue&type=style&index=0&id=810e8af0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-810e8af0"]])

export default __exports__